import { getConfigValue } from '@jutro/config';
import { subscribe, JUTRO_TOPICS, loadGtag, DefaultDictionaryProvider,
    DefaultWhitelistProvider } from '@jutro/events';
import Analytics from '../../../common/capabilities/cpmi-capability-analytics/services/Analytics'
import appConfig from 'app-config';

export default function useGoogleAnalytics() {

    const ga = loadGtag(getConfigValue('GA_TRACKING_ID'));

    function trackGAPageView(title,page){
        ga('set', {
            page: title,
            title: page
        });
        return ga('send', 'pageview',title);

        // return ga('send',{
        //     hitType:'pageview',
        //     title:title,
        //     page:window.location.pathname

        // })

        // ga('set',title);
        // ga('send','pageview',page)
        
    }

    function trackGAEvent(title,page){
        const { trackingConfig = {} } = appConfig;
        const whitelist = DefaultWhitelistProvider.create(trackingConfig.whitelistConfig);
        const translate = DefaultDictionaryProvider.create(
            trackingConfig.dictionaryConfig
        );
        return ga('send', {
            hitType: 'event',
            eventCategory: title,
            // eventAction: topic,
            eventLabel: page,
        });
        // subscribe(
        // ['JUTRO_TOPICS.BUTTON_CLICKED', 'JUTRO_TOPICS.VALUE_CHANGED', 'JUTRO_TOPICS.FIELD_BLUR','JUTRO_TOPICS.LINK_CLICKED'],
        // (event, topic) => {
        //     const transformedEvent = translate(whitelist(event));
        //     console.log("topic",topic);
        //     console.log("transformed event ",JSON.stringify(transformedEvent));
        //     ga('send', {
        //         hitType: 'event',
        //         eventCategory: JSON.stringify(transformedEvent.label),
        //         eventAction: topic,
        //         eventLabel: JSON.stringify(transformedEvent),
        //     });
        // });
      
    }

    return [trackGAPageView,trackGAEvent]
}